import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bk_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function describeApiError(err, fallback = "Something went wrong. Please try again.") {
  if (!err) return fallback;
  if (!err.response) {
    if (err.code === "ECONNABORTED" || /timeout/i.test(err.message || "")) return "The request timed out before the server answered. Check your connection and try again.";
    return "The request never reached the server (connection interrupted or the server restarted). Check your connection and try again.";
  }
  const { status, data } = err.response;
  if (data && data.detail != null) return formatApiErrorDetail(data.detail);
  if (status === 413) return "That file is too large for the server to accept (limit 25 MB).";
  if (status === 502 || status === 503 || status === 504) return `The server didn't finish in time (HTTP ${status}). Try again in a moment.`;
  return `${fallback} (HTTP ${status})`;
}

export function trackStripeCta(plan_name, source_page, source_element) {
  api.post("/analytics/cta-click", { plan_name, source_page, source_element }).catch(() => {});
}
